import WorkspaceTable from './WorkspaceTable';
export default WorkspaceTable;
